import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PaintBucketIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="paintBucket" ref={ref} {...props}>
      <path d="M5,12.07H5Zm18,0a2.72,2.72,0,0,1-.8,1.94l-6.74,6.74a2.76,2.76,0,0,1-3.89,0L3.94,13.14l-.18.17a.74.74,0,0,1-.53.22.73.73,0,0,1-.53-.22.75.75,0,0,1,0-1.06l.64-.63,0,0,0,0,0,0L12.94,2,13,1.92l.06,0,.59-.6a.75.75,0,0,1,1.06,0,.75.75,0,0,1,0,1.06l-.17.18,7.62,7.62A2.73,2.73,0,0,1,23,12.08Zm-18,0H5Zm.75-.76H21.23a.41.41,0,0,0-.1-.13L13.51,3.57Zm-2.41.3,0,0,0,0h0ZM13,2l0,0L13,1.92ZM5,12.07H5Zm0,0H5Zm.07,7.85a10.69,10.69,0,0,0-1.47-2.54,10.34,10.34,0,0,0-1.47,2.54A1.59,1.59,0,0,0,3.59,22,1.59,1.59,0,0,0,5.06,19.92Z" />
    </Icon>
  ),
) as IconWithRender;

PaintBucketIcon.displayName = 'PaintBucketIcon';
PaintBucketIcon.renderIcon = (props) => <PaintBucketIcon {...props} />;
export default PaintBucketIcon;
